import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  itemSkuLabel: {
    defaultMessage: 'SKU: {sku}',
    description: 'Label showing the SKU of an item on the item card',
    id: 'RkAJH7',
  },
  unitLabel: {
    defaultMessage: 'Qty',
    description: 'Label for the quantity input adornment on the item card',
    id: 'Ru6i7B',
  },
});
